import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'unlock/:id',
    loadComponent: () => import('./components/unlock/unlock').then((m) => m.Unlock),
  },
  { path: '**', redirectTo: 'unlock/unknown' },
];
